var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCornering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4847 34.9608L14.1934 23.7598",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1081 34.6235L7.40723 20.9766",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4517 19.8854C14.4517 19.8854 13.0118 18.4742 11.8353 17.2432C9.76141 15.0786 9.60055 13.4544 10.0691 11.7602C10.6408 9.44053 12.4894 7.31487 15.4953 7.50836",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2869 21.777C12.2869 21.777 10.847 20.3642 9.67048 19.1342C7.59663 16.9696 7.14822 15.5129 7.02379 13.3778C6.6477 6.76946 13.0346 4.97852 13.0346 4.97852",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04831 8.59961C4.13077 10.2604 3.17231 15.1156 5.67551 18.7359",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40234 5.11416C7.40234 5.11416 10.5843 1.30931 16.6803 1.81362C21.4889 2.21118 24.4657 6.24288 24.4657 6.24288",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3994 4.66604C15.3994 4.66604 18.3701 4.6349 21.3581 6.89401",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7461 8.52734L20.904 10.7714",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1849 11.4453L29.4697 15.2596",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8174 13.2539L24.848 16.1536",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2781 22.4578L30.6572 20.2793",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0361 24.2383L25.6958 21.168",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0737 20.5897L33.5266 22.9C33.5266 22.9 33.7183 25.0356 32.2088 25.5133C31.432 25.7596 27.3386 26.4524 27.3386 26.4524C25.9665 26.717 24.3579 26.5775 23.9969 24.7371C23.4874 22.136 21.5778 12.3934 21.2034 10.4801C21.1613 10.2648 21.1642 10.0432 21.2118 9.82904L21.3799 9.08008",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0577 22.2402C32.6513 23.4424 24.9007 24.9369 24.2881 23.9311",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7741 12.4084L31.4727 12.1602",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8857 15.0881L21.926 14.0039",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9199 13.484C22.5253 10.7684 28.6728 9.6475 31.1626 11.7048",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7057 18.8623L30.5927 8.59594C30.5001 8.14429 30.2872 7.72552 29.9761 7.38326C29.6622 7.04049 29.3006 6.74392 28.9022 6.50252C28.2386 6.10202 27.4657 5.91679 26.691 5.97263C25.116 6.05993 22.7619 6.50808 22.3096 7.57508",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5525 15.153L30.5087 20.032C30.5256 20.1172 30.5254 20.2049 30.508 20.29C30.4907 20.375 30.4566 20.4559 30.4077 20.5279C30.3588 20.5999 30.2961 20.6616 30.2231 20.7095C30.1501 20.7574 30.0683 20.7906 29.9824 20.8071L26.4513 21.4882C26.2781 21.5217 26.0986 21.4856 25.9523 21.3878C25.806 21.2899 25.7048 21.1385 25.6711 20.9667L24.7148 16.0871C25.5562 14.8021 28.6047 14.3617 29.5525 15.153Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCornering);
export default __webpack_public_path__ + "static/media/ic_cornering.4d4de8aff35ae9427cd69cc1ceb328c8.svg";
export { ForwardRef as ReactComponent };